var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-container',{staticClass:"two-row-element",style:(_vm.styleProps())},[_c('el-main',{staticClass:"two-row-data"},[_vm._t("data")],2),_c('el-footer',{staticClass:"two-row-title"},[_vm._t("title")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }